export const VERSION_MAP = {
    rm10_rm10evo_ecofoot2plus_module_validation_changes: '0.0.2',
    rm5_rmdt_module_validation_changes: '0.0.3',
    // gft_bolt_capacity_calc_change: '0.0.4', Version was removed because it was over 1 year old
    roof_zone_and_classfication_changes: '0.0.5',
    new_to_old_roof_zone_mapping_change: '0.0.6', // unused version 0.0.6
    // non_zero_blocks_rm_notations_change: '0.0.7', Version was removed because it was over 1 year old
    sm_heavy_rail_option: '0.0.8',
    sm_hd_ula_rail_option: '0.0.8',
    rm10evo_row_spacing_change: '0.0.9',
    // small_array_factor_changes: '0.0.10',   Version was removed because it was over 1 year old
    // asd_factor_correction_changes: '0.0.10',    Version was removed because it was over 1 year old
    // eff_area_formula_changes: '0.0.11', Version was removed because it was over 1 year old
    // mri_factor_changes: '0.0.11',   Version was removed because it was over 1 year old
    mid_and_end_clamps_changes_in_gft_ula: '0.0.12',
    remove_gft_166_rail :'0.0.14',
    building_height_factor_and_drag_gcp_changes: '0.0.15',
    velocity_pressure_exposure_coefficient_changes: '0.0.15',
    remove_ula_166_rail : '0.0.16',
    rm5_central_support_changes: '0.0.17',
    module_thickness_changes: '0.0.19',
    panels_rotation_factor_changes_rm_10_evo: '0.0.20',
    rm10_rm10evo_small_array_factor_changes: '0.0.21', // For RM10 & RM10 EVO
    shortest_building_length_changes: '0.0.23', // For RM10, RM10 EVO, RM5 & RMDT
    tension_transverse_clamp_formula_for_mix_match: '0.0.24',
    deadload_factor_limit_changes: '0.0.25',
    soil_class_D_to_D_Default_changes: '0.0.26',        // For RM10, RM10 EVO
    rm5_revamp: '0.0.27',    
    rm10_evo_ballast_based_on_bay_potential_and_rm10_evo_rm5_corrected_attachment_capacity_distribution: '0.0.28',
    rm10_evo_module_clamp_remove: '0.0.28',
    rm10_rm10evo_ecofoot2plus_minimum_setback_validation_and_setback_factor_changes: '0.0.29', // calculation and validation of setback for EF2+, RM10 and RM10 Evo
    module_length_width_validation: '0.0.29',   // width can not be greater than length validation changes
    rmdt_small_array_factor_module_class_changes: '0.0.30',     // TODO CAN BE deleted during version deletion
    solar_eq_factor_for_mod_len_greater_than_84p42: '0.0.31',  // TODO CAN BE deleted during version deletion
    rm5_updated_deflector_selection_and_its_quantity_based_on_module_type: '0.0.32',  // TODO cannot be deleted during version control deletion, as previous projects should retain deflector type condition
    removed_25_yrs_mri_option_in_ef2: '0.0.32', // previous versions sh'ld have mri=25
    sm_tilt_same_span_for_all_zones: '0.0.33',  // TODO can be deleted
    exculde_no_deflector_option_under_wind_deflectors: '0.0.34',
    changing_soil_class_to_d_default_for_building_code_asce_716: '0.0.35',
    remove_user_has_exclusive_access_in_sfm: '0.0.36',
    nxt_mgmt_clip_as_default_accessory_for_nxt: '0.0.37',
    rm5_setback_changes: '0.0.38',
    rm_gridflex_5_setback_changes: '0.0.38',
    rm10_rm10evo_rm5_attachment_capacity_changes: '0.0.38',
    nxt_new_splice_sh_butyl_attachment: '0.0.39',  // TODO cannot be deleted as previous projects use old part
    gft_cantilever_ratio_check_and_ballast_block_engg_corrections: '0.0.40',  // TODO can be deleted
    ula_krinner_new_part_change: '0.0.42',
    rm10_rm10_evo_seismic_attachments_with_goal_seek_approach: '0.0.43',  // TODO can be deleted
    module_length_restrict_to_90inch_for_ef2Plus: '0.0.44',
    nxt_84_inch_rail: '0.0.45',
    mple_combo_clamp_rail_clamp_part_changes: '0.0.45',
    sm_flush_nxt_point_load_and_snow_factor_corrections: '0.0.46', // TODO can't be deleted
    gft_ula_seismic_site_class: '0.0.47',
    lat_lng_to_pixel_conversion_changes : '0.0.48',
    gf10_attachment_part_replacement: '0.0.49', // TODO - can be deleted
    gf5_added_small_array_check_for_dead_load_factor: '0.0.50',  //  can't be deleted,
    skew_factor_changes: '0.0.51',
    module_length_restrict_to_97inch_for_gft: '0.0.51',
    adjustable_tilt_system : '0.0.52',
    update_lateral_bearing_capacity: '0.0.52',
    min_setback_validation_based_on_seismic_design_category: '0.0.52',
    gft_removal_of_old_top_chord_option_and_modified_snow_load_calcs: '0.0.53',
    ula_modified_snow_load_calculations: '0.0.53',
    stacking_tray_for_gf5: '0.0.53',
    nxt_part_changes: '0.0.53',
    remove_upslope_rail_direction_for_flashloc_duo: '0.0.54',
    add_185_inch_rail_sm_standard_and_ascender_rail_update: '0.0.55',
    large_modules_check_sm_tilt_pr: '0.0.55',
    H_and_U_anchor_attachments : '0.0.56',
    rm10_rm10evo_rmdt_removal_of_advantage_in_asd_factor: '0.0.56',
    add_96_and_185_inch_rail_nxt: '0.0.57',
    use_unfactored_attachment_capacity_for_seismic_calcs_all_RMs : '0.0.57',
    remove_sm_light_option: '0.0.58',
    add_185_for_sml: '0.0.58',
    rm5_mid_supports: '0.0.59',
    u_anchor_attachements: '0.0.59',
    front_edge_height_max_limit_change: '0.0.59',
    skew_version_new: '0.0.59',
    remove_blank_map_option: '0.0.59',
    gf5_south_row_panel_editor_updates : '0.0.60',
    gf10_update_additional_south_block_requirement: '0.0.61',
    roof_mounts_psf_limit_greater_than_insufficient_ballasted_system: '0.0.62',
    update_max_block_allowance_gf10: '0.0.62',
    remove_2_rows_special_south_case_from_gf5_gf10: '0.0.63',
    ula_cast_in_place_calculation_update: '0.0.63',
    remove_sm_208_inch_rail : '0.0.63',
    remove_landscape_blocks_orientation_in_gf10 : '0.0.63',
    hide_design_life_factor_fc_for_716_and_722: '0.0.64',
    gf5_tray_capacity_updated_due_to_stacking_issue: '0.0.64',
    u_anchor_improvements : '0.0.64',
    rm5_parapet_height_representation : '0.0.65',
    gf10_min_weight_requirement_removed: '0.0.65',
    obstruction_check_formula_modification : '0.0.65',
    supplemental_sliding_distribution : '0.0.66',
    ecofoot_sub_array_factor_changes : '0.0.66',
    skew_boundary_range_changes : '0.0.66',
    new_gf10_roof_pad_part : '0.0.67', // not used anymore
    default_roofpitch_value_changes: '0.0.67',
    change_in_ef2_plus_weights : '0.0.68',
    default_uanchor_Upliftcapacity_gf5: '0.0.68',
    gf5_part_number_update : '0.0.68',
    gf5_tray_capacity_updated_due_to_central_rails: '0.0.68',
    s5_attachments : '0.0.69',
    gf10_south_rail_extension: '0.0.69',
    new_gf10_part_number_and_description: '0.0.69',
    attachment_capacity_for_custom_attachments_updated: '0.0.69',   
    nxt_SHB_rafters_uplift_capacity_change: '0.0.69',
    ula_update_kd_factor_application_as_per_asce: '0.0.70',
    ecofoot_sub_array_factor_extended_range: '0.0.70',
    sm_lt_tile_replacement_capacities: '0.0.70',
    nxt_capacity_updates_change:'0.0.71',
    nxt_mlpe_mount_domestic_part_change:'0.0.71',
    update_canadian_wind_load_calculations: '0.0.71',
    gf10_residual_uplift_check: '0.0.71',
    apply_skew_factor_above_3ft: '0.0.72',
    rm5_block_size_update: '0.0.72',
    skew_factor_changes_uplift_drag_EF2_plus: '0.0.73',
    restrict_north_corner_to_receive_attachment_help_from_its_loadshare: '0.0.74',
    gridflex_10_parts_update : '0.0.74',
    gf10_aluminium_ballast_hatches : '0.0.74',
    update_gf10_module_length : '0.0.74',
    single_column_restriction: '0.0.74',
    nxt_domestic_combo_clamp_addition: '0.0.75',
    update_north_south_clamp_capacities_GF10d : '0.0.75',
    add_base_rail_capacity_check_GF10d : '0.0.75',
    sm_nxt_butyl_dtd_deck_screw_qty_update: '0.0.76',
    rm10_evo_updated_gcp_for_asce_7_22 : '0.0.76',
    Seismic_attachments_for_SDC_A_and_B: '0.0.76',
    EF2plus_ASCE722_GCP_updates:'0.0.77',
    fully_attached_for_non_feasible_psf_arrays:'0.0.77',
    restrict_north_and_south_corner_to_receive_attachment_help_from_its_loadshare: '0.0.77',
    ecofoot2plus_asce_722_access_for_all: '0.0.77',
    roof_pitch_changes: '0.0.78',
    sm_domestic_content_clamp_filter: '0.0.79',
    gfxd_65in_ballast_rails: '0.0.80',
    swap_user_supplied_part_new_part: '0.0.80',
    q4_mpl_discontinued_parts: '0.0.80',
    distribute_sliding_ballast_across_the_array_gf5d_gf10d: '0.0.80',
}
